<template>
  <v-row>
    <v-col cols="12">
      <h2>Tariffs</h2>

    </v-col>

    <v-col cols="12">
      <v-card>
        <v-card-title>
          <v-spacer></v-spacer>
          <v-spacer></v-spacer>
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            label="Search"
            single-line
            hide-details
          ></v-text-field>
        </v-card-title>
        <v-data-table
          :headers="headers"
          :items="developmentData.tariffs"
          :search="search"
          item-key="name"
          class="elevation-1"
        >
          <template #item.unit_rate="{ value, item }">
            {{ value }}p ({{ item.unit_rate_vat }}% VAT)
          </template>
          <template #item.reviews="{ value }">
            <v-chip
              v-if="value.state === 'danger'"
              color="red"
              dark
              small
            >
              {{ value.date }}
            </v-chip>
            <v-chip
              v-else-if="value.state === 'warning'"
              color="orange"
              dark
              small
            >
              {{ value.date }}
            </v-chip>
            <span v-else>{{ value.date }}</span>
          </template>
          <template #item.standing_charge="{ value, item }">
            {{ value }}p ({{ item.standing_charge_vat }}% VAT)
          </template>
          <template #item.admin_charge="{ value, item }">
            {{ value }}p ({{ item.admin_charge_vat }}% VAT)
          </template>
          <template #item.type="{ value }">
            <v-chip
              v-if="value === 'building'"
              color="#5BccF6"
              dark
            >
              Building
            </v-chip>
            <v-chip
              v-else
              color="#EF9273"
              dark
            >
              Development Meter
            </v-chip>

          </template>

        </v-data-table>
      </v-card>
    </v-col>


  </v-row>
</template>

<script>
import {get} from "vuex-pathify";

export default {
  name: "CreditBillingSingleTariffs",
  computed: {
    developmentData: get('creditBilling/development'),
  },
  data: () => ({
    search: '',
    headers: [
      {
        text: 'Name',
        align: 'start',
        value: 'name',
      },
      {text: 'Unit', value: 'unit'},
      {text: 'Unit Rate', value: 'unit_rate'},
      {text: 'Standing Charge', value: 'standing_charge'},
      {text: 'Admin Charge', value: 'admin_charge'},
      {text: 'Active Meters', value: 'active_associations'},
      {text: 'Total Meters', value: 'meter_associations'},
      {text: 'Tariff End', value: 'reviews'},
    ],
  }),
  methods: {
    formatterDate(value, withoutTime) {
      if (!value) {
        return "";
      }
      return this.formatDate(value, true, !withoutTime);
    }
  }
}
</script>

<style scoped>

</style>
